// custom service for uncaught exceptions (Carlos)
// documentation for custom error handler: https://angular.io/api/core/ErrorHandler (Carlos)

// An equivalent service called `CustomErrorHandlerService` already exists in ng2; hence, this service can be
// removed once the angularjs to angular migration is complete (Carlos)
export default function CustomExceptionHandlerService(Rollbar) {
  return function(exception, cause) {
    Rollbar.error(exception, cause);
    console.error(exception, cause);
  };
}
